import { DashboardFilter } from "../interfaces";

export const FilterDefaultValue: DashboardFilter = {
  search: "",
  tags: [],
  procedure_type: "",
  show_more: true,
};
